export const CURRENT_USER_ID_KEY = 'currentUserId';
export const LAST_LOGIN_DATE_KEY = 'lastLoginDate';

export function getSessionSignature(): string {
  try {
    const lastLoginDate = localStorage.getItem(LAST_LOGIN_DATE_KEY) || '';
    const userId = localStorage.getItem(CURRENT_USER_ID_KEY) || '';
    return `${lastLoginDate}|${userId}`;
  } catch {
    return '';
  }
}

export function getCurrentUserId(): string {
  try {
    return localStorage.getItem(CURRENT_USER_ID_KEY) || '';
  } catch {
    return '';
  }
}

export function setCurrentUserId(userId: string | number): void {
  try {
    localStorage.setItem(CURRENT_USER_ID_KEY, String(userId));
  } catch {}
}

export function clearCurrentUserId(): void {
  try {
    localStorage.removeItem(CURRENT_USER_ID_KEY);
  } catch {}
}
